import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const TableSkeletonRow = () => (
  <tr style={{ height: '3rem' }}>
    <td style={{ padding: '0.5rem', border: 'none' }} className="date">
      <Skeleton width="4rem" height="1.5rem" />
    </td>
    <td style={{ padding: '0.5rem', border: 'none' }} className="label">
      <Skeleton variant="text" width="80%" height="1.5rem" />
    </td>
    <td style={{ padding: '0.5rem', textAlign: 'right', border: 'none' }} className="points">
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Skeleton width="4rem" height="1.5rem" />
      </div>
    </td>
  </tr>
);

export const TableSkeletonRows = ({ rows = 7 }: { rows?: number }) => (
  <>
    {Array.from({ length: rows }).map((_, i) => (
      <TableSkeletonRow key={i} />
    ))}
  </>
);

export function TransactionHistoryTableV2Skeleton({ rows = 5 }: { rows?: number }) {
  return (
    <section
      className="qlfeditor-achievements-history-table--skeleton qlf-skeleton"
      style={{ overflowX: 'auto' }}
      data-testid="skeleton"
      role="status"
      aria-live="polite"
      // not translated as this is backend rendered and while we have the locale at hand, it's not handy to make i18next work with SSR
      aria-label="Loading transactions history"
    >
      <Skeleton height="2rem" width="100%" sx={{ marginBottom: '0.5rem' }} variant="rectangular" />
      <table className="qlf-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <colgroup>
          <col style={{ width: '20%' }} />
          <col style={{ width: '75%' }} />
          <col style={{ width: '15%' }} />
        </colgroup>
        <tbody>
          <TableSkeletonRows rows={rows} />
        </tbody>
      </table>
    </section>
  );
}
